export default {
  FIRST_STEP: {
    TITLE_TASK: 'What does your business do?',
    SUBTITLE: 'Nature of business',
    TOOLTIP: "It’s OK if you haven’t formed this operating company yet. Just tell us what the planned business activities will be once it’s formed. <p>&nbsp;</p> If it is already formed, please also tell us the operating company’s name (or names, if more than one has been formed, separated by a comma).",
    TITLE_EDIT: 'Edit nature of business',
  },
}